import { useNavigate, type NavigateFunction, useRoutes } from "react-router-dom";

import { useEffect } from "react";
import routes from "./config";
import ScrollToTop from "@/components/base/ScrollToTop";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });
  return (
    <>
      <ScrollToTop />
      {element}
    </>
  );
}
